/**
 * @type {Object}
 * @property {array}  accounts  Accounts data
 */
 const initialState = {
    paymentDetailData: [],
    innerPaymentDetailData: [],
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerPaymentDetail = (state = initialState, action) => {
    const newState = { ...state }
    var { data } = action;
    switch (action.type) {
        case 'FETCH_PAYMENT_DETAIL_DATA':
            newState.paymentDetailData = data;
            break;

        case 'FETCH_INNER_PAYMENT_DETAIL_DATA':
            // var { data } = action;
            newState.innerPaymentDetailData = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerPaymentDetail;
